import { render } from "./EnrolledByCountries.vue?vue&type=template&id=6889f312&ts=true"
import script from "./EnrolledByCountries.vue?vue&type=script&lang=ts"
export * from "./EnrolledByCountries.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__